<template>
  <div class="honorRoll" :style="{ background: `linear-gradient(180deg, ${homeConfig.gradientBgTop}, ${homeConfig.gradientBgBottom})` }">
    <header>
      <header-banner :bannerUrl="homeConfig.homepageHeaderImage" />
    </header>
    <section>
      <div class="content">
        <div class="redIcon"><img src="../../assets/images/winterGame/redIcon.png" alt=""></div>
        <div class="top">
          <p>2024冬季赛奖励发放</p>
          <p>请查看现金账户的充值流水<br/>充值方式：松鼠杯奖励金额</p>
        </div>
        <div class="list" v-if="getList.length > 0">
          <div class="getContent" v-for="(item,index) in getList" :key="index">
            <div class="bonusContent">
              <div class="bonusTitle">{{ item.itemName }}</div>
              <div class="bonusDate">{{ item.itemDate }}</div>
            </div>
            <div class="bonusNum" :class="[item.isPlus?'addNum':'subtract']"> <span>{{ item.isPlus ? '+' : '-'}}</span>{{ item.amount }}</div>
          </div>
        </div>
        <div class="emptyData" v-else>
          <p>暂无奖励发放</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import emptyData from "./components/emptyData.vue";
import HeaderBanner from "@views/WinterGame/components/headerBanner.vue";
import { cupReward, queryseasonpersonalhome } from "../../api/winterGame";

export default {
  components: {
    HeaderBanner,
    emptyData,
  },
  data() {
    return {
      getList:[ ],
      teamInfo: {
        cupYearSeason: "",
      },
      scheduleId: "",
      campusId: "",
      seasonId: "",
      currentSeason: null,
      homeConfig: {},
    };
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯";
  },
  mounted() {
    this.campusId = this.$route.query.campusId;
    this.seasonId = this.$route.query.seasonId;
    this.initTeamInfo();
    this.queryCupReward();
    this.querySeasonPersonalHome();
  },
  methods: {
    initTeamInfo() {
      if (this.currentSeason) {
        this.teamInfo = this.currentSeason;
      } else {
        let teamInfo = localStorage.getItem("teamInfo");
        this.teamInfo = JSON.parse(teamInfo);
      }
    },
    querySeasonPersonalHome() {
      queryseasonpersonalhome({
        param: {
          seasonTagId: this.seasonId,
        }
      }).then(res => {
        if (res.code == 0) {
          this.homeConfig = res.data;
        } else {
          Toast(res.message);
        }
      });
    },
     // 经销商奖励发放数据
     async queryCupReward() {
      let params = {
        param: {
          campusId: this.campusId,
          seasonTagId: this.seasonId,
        }
      };
      let res = await cupReward(params);
      if (res.code == 0) {
        if (res.data) {
          this.getList = res.data.items;
        }
      } else {
        Toast(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.honorRoll {
  min-height: 100vh;
  overflow: hidden;

  header {
    height: 334px;
    position: relative;
    img {
      width: 100%;
    }
  }
  .content{
    position: relative;
    background-color: #ffffff;
    margin: 40px;
    padding: 48px;
    border-radius: 8px;
    height: calc(100vh - 425px);
    .redIcon {
        position: absolute;
        top: -50px;
        left: -35px;
        img {
          width: 105%;
        }
      }
    .top  {
      position: relative;
      z-index: 111;
      border-bottom: 3px solid #DEE5F0;
      p{
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
      }
      p:nth-child(1){
        line-height: 10px;
        font-size: 40px;
        color: #323232;
      }
      p:nth-child(2){
        font-size: 28px;
        color: #68707D;
      }
    }
  }

  .list {
    margin-top: 24px;
    height: calc(100vh - 720px);
    overflow: scroll;
    .getContent {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 46px;
        .bonusTitle {
          font-size: 32px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #323232;
        }
        .bonusDate {
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #68707D;
        }
        .bonusNum {
          font-size: 48px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
        }
        .addNum{
          color: #EE4B4E;
        }
        .subtract{
          color: #2bae54;
        }
      }
  }
  .emptyData {
    text-align: center;
    margin-top: 86px;
    img {
      width: 386px;
    }
    p {
      margin-top: 48px;
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 40px;
    }
  }
}
</style>
